<template>
  <div>
    <DataTable
      :value="lstDirectoriosUnidades"
      v-model:expandedRows="expandedRows"
      dataKey="Id_directorio_unidad"
      ref="dt"
      v-model:filters="filters"
      :globalFilterFields="[
        'Unidad',
        'Linea_telefonica',
        'Tipo_estatus',
        'Ubicacion',
        'Id_referencia',
        'Internet',
        'Tipo_medio',
        'Velocidad_internet',
        'Tipo_linea',
        'Tipo_regimen',
        'Observacion',
      ]"
      :loading="loading"
      :paginator="true"
      :rows="20"
      responsiveLayout="scroll"
    >
      <template #header>
        <div class="table-header-container">
          <Button
            icon="pi pi-plus"
            label="Expandir todos"
            @click="expandAll"
            class="mr-2"
          />
          <Button
            icon="pi pi-minus"
            label="Colapsar todos"
            @click="collapseAll"
          />

          <download-excel
            class="btn mr-2"
            :data="lstDirectoriosUnidades"
            :fields="fieldsExport"
            :stringifyLongNum="true"
            :name="'directorio_unidades.xls'"
          >
            <Button
              label="Exportar"
              icon="pi pi-external-link"
              class="p-button-warning"
              style="margin-left: 50px"
            />
          </download-excel>

          <Button
            style="margin-left: 3px"
            label="Nuevo"
            icon="pi pi-plus"
            class="p-button-success mr-2"
            @click="agregarDirectorio"
          />
        </div>
        <div class="table-header">
          <h5>Equipos</h5>
          <span
            >Número de equipos
            {{
              lstDirectoriosUnidades ? lstDirectoriosUnidades.length : 0
            }}</span
          >
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              type="text"
              v-model="filters['global'].value"
              placeholder="Buscar..."
            />
          </span>
        </div>
      </template>

      <template #empty> No se encontraron registros. </template>
      <template #loading> Cargando datos. Espere por favor. </template>

      <Column :expander="true" headerStyle="width: 3rem" />
      <Column field="Unidad" header="Unidad" sortable />
      <Column field="Linea_telefonica" header="Línea telefónica" sortable />
      <Column field="Tipo_estatus" header="Estatus" sortable />
      <Column :exportable="false">
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success"
            @click="edit(slotProps.data)"
          />
          <Button
            style="margin-left: 8px"
            icon="pi pi-times"
            class="p-button-rounded p-button-danger"
            @click="borrar(slotProps.data)"
          />
        </template>
      </Column>

      <template #expansion="slotProps">
        <Card>
          <template #content>
            <div class="grid">
              <div class="col-4">
                <div class="grid">
                  <div class="col title">Ubicación</div>
                  <div class="col data">{{ slotProps.data.Ubicacion }}</div>
                </div>
                <div class="grid">
                  <div class="col title">Tipo de Medio</div>
                  <div class="col data">{{ slotProps.data.Tipo_medio }}</div>
                </div>
                <div class="grid">
                  <div class="col title">Tipo de Linea</div>
                  <div class="col data">{{ slotProps.data.Tipo_linea }}</div>
                </div>
              </div>

              <div class="col-4">
                <div class="grid">
                  <div class="col title">Contacto en Sitio</div>
                  <div class="col data">{{ slotProps.data.Responsable }}</div>
                </div>
                <div class="grid">
                  <div class="col title">Direccion Inmueble</div>
                  <div class="col data">{{ slotProps.data.Direccion }}</div>
                </div>
                <div class="grid">
                  <div class="col title">Regimen</div>
                  <div class="col data">{{ slotProps.data.Tipo_regimen }}</div>
                </div>
              </div>

              <div class="col-4">
                <div class="grid">
                  <div class="col title">Tiene Internet</div>
                  <div class="col data">
                    {{ slotProps.data.Internet == 1 ? "SI" : "NO" }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">Velocidad de Internet</div>
                  <div class="col data">
                    {{ slotProps.data.Velocidad_internet }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">Observaciones</div>
                  <div class="col data">{{ slotProps.data.Observaciones }}</div>
                </div>
              </div>
            </div>
          </template>
        </Card>
      </template>

      <template #footer>
        Registros en total
        {{ lstDirectoriosUnidades ? lstDirectoriosUnidades.length : 0 }}
      </template>
    </DataTable>
  </div>

  <Dialog
    :style="{ width: '750px' }"
    :visible="showAgregar"
    :modal="true"
    class="p-fluid"
    :closable="false"
  >
    <template #header>
      <h3>{{ modoEdicion }} directorio</h3>
    </template>

    <div class="p-formgrid grid">
      <div class="p-field col">
        <label for="unidad">Unidad</label>
        <Dropdown
            id="unidad"
            appendTo="body"
            v-model="DirectorioUnidad.Subred_unidad"
            :filter="true"
            :options="lstUnidades"
            optionLabel="UNIDAD_SUBRED"
            optionValue="SUBRED"
            placeholder="Selecciona una unidad"
            :class="{ 'p-invalid': submitted && !DirectorioUnidad.Subred_unidad }"
            @change="OnUnidadChange"  
            />
        <small
          style="color: red"
          class="p-invalid"
          v-if="submitted && !DirectorioUnidad.Subred_unidad"
        >
          La unidad es requerida.
        </small>
      </div>

      <div class="p-field col">
        <label for="referencia">Referencia</label>
        <InputText
          id="referencia"
          v-model="DirectorioUnidad.Referencia"
          readonly
        />
      </div>
    </div>

    <div class="p-formgrid grid">
      <div class="p-field col">
        <label for="Responsable">Contacto</label>
        <InputText
          autocomplete="off"
          id="Responsable"
          v-model.trim="DirectorioUnidad.Responsable"
          readonly
        />
      </div>

      <div class="p-field col">
        <label for="telefono">Línea telefónica</label>
        <InputText
          autocomplete="off"
          id="telefono"
          v-model.trim="DirectorioUnidad.Linea_telefonica"
          required="true"
          autofocus
          @keypress="soloNumeros($event)"
          @input="limitarLongitud"
          :class="{
            'p-invalid':
              submitted &&
              (!DirectorioUnidad.Linea_telefonica ||
                !esTelefonoValido(DirectorioUnidad.Linea_telefonica)),
          }"
        />
        <small
          style="color: red"
          class="p-invalid"
          v-if="submitted && !DirectorioUnidad.Linea_telefonica"
        >
          El teléfono es requerido.
        </small>
        <small
          class="p-invalid"
          v-if="
            submitted &&
            DirectorioUnidad.Linea_telefonica &&
            !esTelefonoValido(DirectorioUnidad.Linea_telefonica)
          "
        >
          El teléfono debe tener exactamente 10 dígitos.
        </small>
      </div>

      <div class="p-field col" style="display: flex; align-items: center">
        <label for="ubicacion" style="margin-right: 5px">Tiene internet</label>
        <Checkbox
          id="tieneInternet"
          v-model="DirectorioUnidad.Internet"
          :binary="true"
          :class="{
            'p-invalid': submitted && DirectorioUnidad.Internet === undefined,
          }"
          inputId="tieneInternet"
          class="p-mr-2"
        />
      </div>
    </div>

    <div class="p-formgrid grid">
      <div class="p-field col">
        <label for="unidad">Tipo medio</label>
        <Dropdown
          id="unidad"
          appendTo="body"
          v-model="DirectorioUnidad.Id_tipo_medio"
          :options="lstTiposMedios"
          optionLabel="Descripcion"
          optionValue="Id_tipo_medio"
          placeholder="Selecciona un tipo de medio"
          :class="{ 'p-invalid': submitted && !DirectorioUnidad.Id_tipo_medio }"
        />
        <small
          style="color: red"
          class="p-invalid"
          v-if="submitted && !DirectorioUnidad.Id_tipo_medio"
        >
          El tipo de medio es requerida.
        </small>
      </div>

      <div class="p-field col">
        <label for="ubicacion">Velocidad de internet</label>
        <InputText
          autocomplete="off"
          id="ubicacion"
          v-model.trim="DirectorioUnidad.Velocidad_internet"
          :disabled="!DirectorioUnidad.Internet"
          autofocus
        />
      </div>
      <div class="p-field col">
        <label for="unidad">Tipo de linea</label>
        <Dropdown
          id="unidad"
          appendTo="body"
          v-model="DirectorioUnidad.Id_tipo_linea"
          :options="lstTiposLineas"
          optionLabel="Descripcion"
          optionValue="Id_tipo_linea"
          placeholder="Selecciona un tipo de linea"
          :class="{ 'p-invalid': submitted && !DirectorioUnidad.Id_tipo_linea }"
        />
        <small
          style="color: red"
          class="p-invalid"
          v-if="submitted && !DirectorioUnidad.Id_tipo_linea"
        >
          El tipo de linea es requerida.
        </small>
      </div>
    </div>

    <div class="p-formgrid grid">
      <div class="p-field col">
        <label for="ubicacion">Regimen</label>
        <Dropdown
          id="unidad"
          appendTo="body"
          v-model="DirectorioUnidad.Id_regimen"
          :options="lstTiposRegimenes"
          optionLabel="Descripcion"
          optionValue="Id_regimen"
          placeholder="Selecciona un regimen"
          :class="{ 'p-invalid': submitted && !DirectorioUnidad.Id_regimen }"
        />
        <small
          style="color: red"
          class="p-invalid"
          v-if="submitted && !DirectorioUnidad.Id_regimen"
        >
          El regimen es requerida.
        </small>
      </div>

      <div class="p-field col">
        <label for="ubicacion">Ubicacion</label>
        <InputText
          autocomplete="off"
          id="ubicacion"
          v-model.trim="DirectorioUnidad.Ubicacion"
          required="true"
          autofocus
          :class="{ 'p-invalid': submitted && !DirectorioUnidad.Ubicacion }"
        />
        <small
          style="color: red"
          class="p-invalid"
          v-if="submitted && !DirectorioUnidad.Ubicacion"
          >La ubicación es requerida.</small
        >
      </div>

      <div class="p-field col">
        <label for="unidad">Estatus</label>
        <Dropdown
          id="estatus"
          appendTo="body"
          v-model="DirectorioUnidad.Id_estatus"
          :options="lstEstatus"
          optionLabel="Descripcion"
          optionValue="Id_estatus"
          placeholder="Selecciona un estatus"
          :class="{ 'p-invalid': submitted && !DirectorioUnidad.Id_estatus }"
        />
        <small
          style="color: red"
          class="p-invalid"
          v-if="submitted && !DirectorioUnidad.Id_estatus"
        >
          El estatus es requerida.
        </small>
      </div>
    </div>

    <div class="p-formgrid grid">
      <div class="p-field col">
        <label for="Direccion">Direccion</label>
        <InputText
          autocomplete="off"
          id="Direccion"
          v-model.trim="DirectorioUnidad.Direccion"
          autofocus
          readonly
        />
      </div>
      <div class="p-field col">
        <label for="ubicacion">Observaciones</label>
        <InputText
          autocomplete="off"
          id="ubicacion"
          v-model.trim="DirectorioUnidad.Observaciones"
          required="true"
          autofocus
        />
      </div>
    </div>
    <template #footer>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-text"
        @click="cancelarDialogo"
      />
      <Button
        label="Guardar"
        icon="pi pi-check"
        class="p-button-text"
        @click="guardarDirectorio"
      />
    </template>
  </Dialog>

  <ConfirmDialog></ConfirmDialog>
</template>

<script>
import Srvr from "../service/DirectorioUnidad";
import SrvrUni from "../service/Unidades";
import SrvrU from "../service/Inventario";
import SrvrRef from "../service/Referencias";
import { ConfirmDialog } from "primevue/confirmdialog";

export default {
  components: { ConfirmDialog },
  data() {
    return {
      // Listas (Catálogos)
      lstReferencias: [],
      referenciasFiltradas: [],
      lstUnidades: [],
      lstUnidadMaestra: [], // Antes lstUnidad
      lstEstatus: [],
      lstTiposMedios: [],
      lstTiposLineas: [],
      lstTiposRegimenes: [],
      
      // Datos principales
      lstDirectoriosUnidades: [],
      expandedRows: [],
      
      // Control
      submitted: false,
      loading: false,
      showAgregar: false,
      modoEdicion: "",
      filters: { global: { value: null, matchMode: "contains" } },
      
      // Modelo
      DirectorioUnidad: this.getModeloVacio(),
      
      // Exportación
      fieldsExport: {
        Unidad: "Unidad",
        Linea_telefonica: "Linea_telefonica",
        Tipo_estatus: "Tipo_estatus",
        Ubicacion: "Ubicacion",
        Internet: "Internet",
        Tipo_medio: "Tipo_medio",
        Velocidad_internet: "Velocidad_internet",
        Tipo_linea: "Tipo_linea",
        Tipo_regimen: "Tipo_regimen",
        Observaciones: "Observaciones",
        No_llamadas: "No_llamadas",
      },
    };
  },
  mounted() {
    this.cargaInicialCompleta();
  },
  watch: {
    "DirectorioUnidad.Internet"(nuevoValor) {
      if (!nuevoValor) this.DirectorioUnidad.Velocidad_internet = "";
    },
  },
  methods: {
    getModeloVacio() {
      return {
        Id_directorio_unidad: null,
        Id_unidad: null,
        Id_estatus: null,
        Id_tipo_medio: null,
        Id_tipo_linea: null,
        Id_regimen: null,
        Id_referencia: null,
        Unidad: "",
        Linea_telefonica: "",
        Subred_unidad: "", // El v-model del dropdown
        Direccion: "",
        Responsable: "",
        Referencia: "",
        Ubicacion: "",
        Tipo_estatus: "",
        Tipo_medio: "",
        Tipo_linea: "",
        Tipo_regimen: "",
        Internet: false,
        Velocidad_internet: "",
        Observaciones: "",
        No_llamadas: "",
      };
    },

    cargaInicialCompleta() {
      this.loading = true;
      const ctlSvr = new Srvr();
      const ctlSvrU = new SrvrU();
      const ctlSvrRef = new SrvrRef();
      const ctlSvrUni = new SrvrUni();

      Promise.all([
        ctlSvr.getDirectoriosUnidades(this),
        ctlSvrRef.getReferencias(this),         
        ctlSvrU.getUnidades(this),              
        ctlSvr.getEstatusActivos(this),         
        ctlSvr.getTiposMediosActivos(this),     
        ctlSvr.getTiposLineasActivos(this),     
        ctlSvr.getTiposRegimenesActivos(this),  
        ctlSvrUni.getAll(this),                 
      ])
        .then((res) => {
          this.lstDirectoriosUnidades = res[0];
          this.lstReferencias = res[1];
          this.lstUnidades = res[2];
          this.lstEstatus = res[3];
          this.lstTiposMedios = res[4];
          this.lstTiposLineas = res[5];
          this.lstTiposRegimenes = res[6];
          this.lstUnidadMaestra = res[7];

          this.mapearNombresReferencias();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.error("Error cargando datos:", err);
        });
    },

    mapearNombresReferencias() {
      const mapa = new Map(this.lstReferencias.map((r) => [r.Id_referencia, r]));
      this.lstDirectoriosUnidades.forEach((dir) => {
        const ref = mapa.get(dir.Id_referencia);
        dir.Referencia = ref ? ref.Referencia : dir.Id_referencia;
        dir.Responsable = ref ? ref.Responsable : "No asignado";
      });
    },

    OnUnidadChange(event) {
        const subredSeleccionada = event && event.value ? event.value : this.DirectorioUnidad.Subred_unidad;

        if (!subredSeleccionada) {
            this.limpiarDatosUnidad();
            return;
        }

        const unidadObj = this.lstUnidades.find(u => u.SUBRED === subredSeleccionada);

        if (unidadObj) {
            this.DirectorioUnidad.Id_unidad = unidadObj.Id_unidad;
            this.DirectorioUnidad.Unidad = unidadObj.UNIDAD;
            
            if (!this.DirectorioUnidad.Direccion) {
                 this.DirectorioUnidad.Direccion = unidadObj.Direccion || '';
            }
        }

        //Filtrar y asignar Referencias (Contactos)
        this.procesarReferencias(subredSeleccionada);
    },

    limpiarDatosUnidad() {
        this.DirectorioUnidad.Id_unidad = null;
        this.DirectorioUnidad.Unidad = "";
        this.DirectorioUnidad.Direccion = "";
        this.DirectorioUnidad.Responsable = "";
        this.DirectorioUnidad.Referencia = "";
        this.referenciasFiltradas = [];
    },

    procesarReferencias(subred) {
        // Filtrar lista
        if (this.lstReferencias && this.lstReferencias.length > 0) {
             this.referenciasFiltradas = this.lstReferencias.filter(
                r => r.Segmento === subred
            );
        } else {
            this.referenciasFiltradas = [];
        }

        // Asignar primer contacto encontrado
        const ref = this.referenciasFiltradas[0] || {};
        this.DirectorioUnidad.Responsable = ref.Responsable || "";
        this.DirectorioUnidad.Referencia = ref.Referencia || "";
        this.DirectorioUnidad.Id_referencia = ref.Id_referencia || null;
        
        // Si la referencia tiene dirección y el campo está vacío, se usa como respaldo
        if (!this.DirectorioUnidad.Direccion && ref.Direccion) {
            this.DirectorioUnidad.Direccion = ref.Direccion;
        }
    },

    // ACCIONES DEL USUARIO
    agregarDirectorio() {
      this.modoEdicion = "Agregar";
      this.submitted = false;
      this.DirectorioUnidad = this.getModeloVacio();
      this.referenciasFiltradas = [];
      this.showAgregar = true;
    },

    edit(obj) {
      this.modoEdicion = "Editar";
      this.submitted = false;
      
      // Clonar objeto para no editar la tabla directamente
      this.DirectorioUnidad = { ...obj }; 
      
      // Recuperar la Subred basada en el nombre de Unidad (para que el combo se seleccione)
      const unidadEncontrada = this.lstUnidades.find(u => u.UNIDAD === obj.Unidad);
      if (unidadEncontrada) {
          this.DirectorioUnidad.Subred_unidad = unidadEncontrada.SUBRED;
          // No sobrescribir dirección si ya trae una
          this.procesarReferencias(unidadEncontrada.SUBRED);
      }

      this.showAgregar = true;
    },

    guardarDirectorio() {
      this.submitted = true;
      
      // Validaciones básicas
      if (!this.DirectorioUnidad.Subred_unidad) return; // Dropdown vacío
      if (!this.esTelefonoValido(this.DirectorioUnidad.Linea_telefonica)) return;
      if (!this.DirectorioUnidad.Id_estatus) return;

      this.llenarDescripcionesPorId();

      const ctlSvr = new Srvr();
      
      
      const payload = { ...this.DirectorioUnidad };
      
      payload.Segmento = this.DirectorioUnidad.Subred_unidad; 
      
      const operacion = this.DirectorioUnidad.Id_directorio_unidad
        ? ctlSvr.Update(this, payload)
        : (delete payload.Id_directorio_unidad, ctlSvr.Add(this, payload));

      operacion.then(() => {
        this.$toast.add({
          severity: "success",
          summary: "Éxito",
          detail: "Registro guardado correctamente",
          life: 3000,
        });
        this.cancelarDialogo();
        this.cargaInicialCompleta(); // Recargar tabla
      });
    },

    llenarDescripcionesPorId() {
        // Helpers para buscar texto por ID
        const findDesc = (list, idField, idVal) => {
            const item = list.find(x => x[idField] === idVal);
            return item ? item.Descripcion : "";
        };

        this.DirectorioUnidad.Tipo_estatus = findDesc(this.lstEstatus, 'Id_estatus', this.DirectorioUnidad.Id_estatus);
        this.DirectorioUnidad.Tipo_medio = findDesc(this.lstTiposMedios, 'Id_tipo_medio', this.DirectorioUnidad.Id_tipo_medio);
        this.DirectorioUnidad.Tipo_linea = findDesc(this.lstTiposLineas, 'Id_tipo_linea', this.DirectorioUnidad.Id_tipo_linea);
        this.DirectorioUnidad.Tipo_regimen = findDesc(this.lstTiposRegimenes, 'Id_regimen', this.DirectorioUnidad.Id_regimen);
    },

    cancelarDialogo() {
      this.showAgregar = false;
      this.DirectorioUnidad = this.getModeloVacio();
    },

    borrar(obj) {
      this.$confirm.require({
        message: "¿Quiere eliminar este registro?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        acceptClass: "p-button-danger",
        accept: () => {
          new Srvr().Delete(this, obj.Id_directorio_unidad).then(() => {
            this.$toast.add({ severity: "success", summary: "Eliminado", detail: "Registro eliminado", life: 3000 });
            this.cargaInicialCompleta();
          });
        },
      });
    },

    // Utilidades
    expandAll() {
      this.expandedRows = {};
      this.lstDirectoriosUnidades.forEach(i => this.expandedRows[i.Id_directorio_unidad] = true);
    },
    collapseAll() { this.expandedRows = {}; },
    soloNumeros(evt) {
      if (evt.which > 31 && (evt.which < 48 || evt.which > 57)) evt.preventDefault();
    },
    limitarLongitud() {
      if (this.DirectorioUnidad.Linea_telefonica.length > 10) 
        this.DirectorioUnidad.Linea_telefonica = this.DirectorioUnidad.Linea_telefonica.slice(0, 10);
    },
    esTelefonoValido(tel) { return /^\d{10}$/.test(tel); },
  },
};
</script>

<style scoped>
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-header-container {
  display: flex;
  margin-bottom: 10px;
}
.title {
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-right: 10px;
  text-transform: uppercase;
}
.data {
  letter-spacing: 0.5px;
  margin-right: 10px;
}
</style>
